import "@/plugins/vueApplicationInsights";
import "@/plugins/tooltip";
import "@/plugins/vuePortal";
import "@/plugins/notifications";
import "@/plugins/confirmationDialog";
import "@/plugins/casl";
import "@/plugins/vuelidate";
import "@/plugins/vuelidate-error-extractor";
import "@/plugins/vcalendar";
import "@/plugins/vue-ctk-date-time-picker";
import "@/plugins/vueTelInput/vueTelInput";
import "@/plugins/loadScript";
import "@/plugins/vueClipboard";
import "@/plugins/vidyo-plugin";
import "@/plugins/vueMultiSelect";
import "@/plugins/v-wave";
import "@/plugins/vueMq";
import "@/plugins/outdated-browser";

// Captcha support is disabled for now
//import "./plugins/recaptcha";
